import React from 'react'
import { IAddressCard } from './IAddressCard'
import { Box, Grid, Typography } from '@mui/material'
import MapLink from '../../mapLink/mapLink'

const AddressCard = ({ address, latitude, longitude, phones, lable }: IAddressCard) => {
    return (
        <Box sx={{ background: "var(--input-bg-color)", border: "1px solid var(--border-color)", borderRadius: "5px", padding: "0px 20px" }}>
            <Grid container sx={{ flexDirection: "column", paddingY: "1rem", width: '100%', alignItems: "flex-start", justifyContent: "space-between" }}>
                <Grid item >
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        <Grid item sx={{ fontSize: ".9rem", color: "var(--tirnary-text-color)" }}>{address}</Grid>
                        {(latitude || longitude) && <Grid item sx={{ marginBottom: "10px", color: "#BBA57A", fontSize: ".8rem" }}>
                            <MapLink latitude={latitude} longitude={longitude} label={lable} />
                        </Grid>}
                    </Box>
                </Grid>
                <hr style={{ width: "100%", borderColor: "var(--hr-color)", backgroundColor: "var(--hr-color)", height: "1px" }} />
                <Grid sx={{ marginTop: "10px", color: "#BBA57A", fontSize: ".9rem", display: "flex", gap: "10px", flexWrap: "wrap" }} item >
                    {phones?.map((item, index) => (
                        <Typography key={index} sx={{ fontSize: ".9rem" }}>{item}{index === phones.length - 1 ? "" : "،"}</Typography>
                    ))}
                </Grid>
            </Grid>
        </Box>
    )
}

export default AddressCard